/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link, Typography } from '@ntuctech/devex-tangram';

import styled from 'styled-components';
import Accordion from '../../Accordion';

const StyledLi = styled.li`
  &:before {
    content: '•';
    margin-right: 0.5rem;
  }
`;

const StyledUl = styled.ul`
  margin-top: 0.25rem;
  padding: 0 1rem 1rem 1rem;
`;

const WhereToRedeemAccordion = () => {
  return (
    <Accordion title="Where to redeem">
      <Typography variant="bodyM">Redeem online</Typography>
      <StyledUl>
        <StyledLi>
          <Typography variant="bodyM">
            FairPrice online (
            <Link
              data-testid="fairprice-online-link"
              size="m"
              onClick={() => {
                window.open('https://fairprice.com.sg/', '_blank');
              }}
            >
              www.fairprice.com.sg
            </Link>
            )
          </Typography>
        </StyledLi>
      </StyledUl>
      <Typography variant="bodyM">Redeem in-stores</Typography>
      <StyledUl>
        <StyledLi>
          <Typography variant="bodyM">FairPrice supermarkets</Typography>
        </StyledLi>
        <StyledLi>
          <Typography variant="bodyM">FairPrice Xtra</Typography>
        </StyledLi>
        <StyledLi>
          <Typography variant="bodyM">FairPrice Finest</Typography>
        </StyledLi>
        <StyledLi>
          <Typography variant="bodyM">FairPrice Shop</Typography>
        </StyledLi>
        <StyledLi>
          <Typography variant="bodyM">Unity Pharmacy (except Changi Airport)</Typography>
        </StyledLi>
      </StyledUl>
    </Accordion>
  );
};

export default WhereToRedeemAccordion;
